  if (!localStorage.getItem("userCountryCode")) {
        fetch("https://ipwho.is/")
          .then(res => res.json())
          .then(data => {
            localStorage.setItem("userCountryCode", data.country_code);
            handleLocationLogic(data.country_code);
          });
      } else {
        handleLocationLogic(localStorage.getItem("userCountryCode"));
      }

      function handleLocationLogic(code) {
        if (code == "GB") {
                    const content = document.querySelectorAll(".uk-only-content");
                    
                    if(content){
                        content.forEach(el => {
                          el.style.display = "block"
                        })
                    }
                  }else{
                    const nonUkMessage = document.querySelector(".non-uk-message")                    
                    if(nonUkMessage){
                      nonUkMessage.style.display = "block"
                    }
                  }
      }